module.exports = __webpack_public_path__ + "media/mypage/images/bg_japan-dfdc0d5e454495501dcdce80bde9714c.jpg";